import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/order-wise-revenue-export';

const unwrap = (response) => response.data?.data ?? response.data;

const orderWiseRevenueExportService = {
  /**
   * Paginated order-wise revenue rows for Excel export.
   * @returns {{ records, total, start_date, end_date, pagination }}
   */
  list: async ({ startDate, endDate, page = 1, limit = 100 } = {}) => {
    const response = await apiClient.get(BASE, {
      params: {
        start_date: startDate,
        end_date: endDate,
        page,
        limit,
      },
    });
    return unwrap(response);
  },
};

export default orderWiseRevenueExportService;
